import { cn } from '../../../../../../../../utils/styles';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import { useMessageManagerProvider } from '../../../../../../../context/messageManager';
import Icons from '../../../../../../../../components/Common/Icons/Icons';
import { IBuilderStep2Data } from '../../../Data';
import { Empty } from '../../index';
import ModalDeleteModule from '../../Modals/Delete';

export interface BuilderModuleProps {
  className?: string;
}

function ImageModule({ className }: BuilderModuleProps) {
  const { state, handleDispatch, selectedModule, handleSelectedModule, handleIsTextOnly } = useMessageManagerProvider();

  const handeAddImageModule = () => {
    if (state.step2.statement.data.length < 5) {
      const newData: IBuilderStep2Data[] = [
        ...state.step2.statement.data,
        {
          id: crypto.randomUUID(),
          content: [''],
          imageUrl: '',
          qrCode: false,
          eStatement: true,
          criteria: [],
          textCriteria: [],
        },
      ];

      handleDispatch({
        step2: {
          ...state.step2,
          statement: {
            ...state.step2.statement,
            data: newData,
          },
        },
      });
    }
  };

  return (
    <div
      className={cn(
        'bg-lightGray2 min-h-[300px] border rounded-lg grid grid-rows-[auto,1fr] overflow-hidden',
        className,
      )}
    >
      <div
        className={cn('bg-[#c6cfdb] p-[2px] pb-[3px]', {
          'bg-primary': state.step2.statement.mode === 'image',
        })}
      >
        <div
          className="flex gap-[3px] [&_button]:w-[44px] [&_button]:p-[10px]
        [&_button]:border-white [&_button]:border-[2px] [&_button]:bg-transparent [&_button]:text-white
        [&_button]:hover:text-white"
        >
          {state.step2.statement.data?.map((el, index) => (
            <Button
              key={el.id}
              variant="outline"
              className={cn({
                '!bg-white !text-addition1 !hover:bg-white': el.id === selectedModule?.item?.id,
              })}
              onClick={() => {
                const newData = state.step2.statement.data.map(el2 =>
                  el2.id === selectedModule?.item?.id ? selectedModule.item : el2,
                );

                handleDispatch({
                  step2: {
                    ...state.step2,
                    statement: {
                      ...state.step2.statement,
                      data: newData,
                      mode: 'image',
                    },
                  },
                });
                handleIsTextOnly(false);

                if (el.id !== selectedModule?.item?.id) {
                  handleSelectedModule({ item: el, imageTabIndex: index, textTabIndex: undefined });
                }
              }}
            >
              {index + 1}
            </Button>
          ))}
          <Button className="!bg-transparent" onClick={handeAddImageModule}>
            <Icons.PlusFilled className="mx-auto" />
          </Button>
        </div>
      </div>
      {selectedModule?.item?.imageUrl && state.step2.statement.mode === 'image' ? (
        <div className="relative group bg-lightGray2">
          <ModalDeleteModule />
          <img
            src={
              selectedModule.item.qrCode && !selectedModule.item.eStatement
                ? '/infoTrac/images/step-2-QR.png'
                : selectedModule?.item?.imageUrl
            }
            alt="module"
            className={cn('w-full h-[254px] object-contain', {
              grayscale: !selectedModule.item.eStatement && !selectedModule.item.qrCode,
            })}
          />
        </div>
      ) : (
        <Empty />
      )}
    </div>
  );
}

ImageModule.defaultProps = {
  className: '',
};

export default ImageModule;
